import React from 'react';

import { ModalPreloader } from 'src/components/Modal';
import { useSearchParams } from 'react-router-dom';

const modalsCache: Record<string, React.LazyExoticComponent<React.ComponentType>> = {};

export const SearchAsyncModal = () => {
  const [searchParams] = useSearchParams();
  const modal = searchParams.get('modal');

  const ModalComponent = React.useMemo(() => {
    if (!modal) return null;
    if (!modalsCache[modal]) {
      //@ts-ignore
      modalsCache[modal] = React.lazy(() =>
        import(`./${modal}`).catch(() => ({ default: () => <></> }))
      );
    }
    return modalsCache[modal];
  }, [modal]);

  if (!ModalComponent) {
    return <></>;
  }

  return (
    <React.Suspense fallback={<ModalPreloader />}>
      <ModalComponent />
    </React.Suspense>
  );
};
